import React from "react";
import { Button } from "antd";
import { useHistory } from "react-router-dom";

export default function FreeRenderLimit() {
  let history = useHistory();

  const handleClick = () => {
    history.push("/pricing");
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        color: "#f5f5f5",
        fontSize: "1.5rem",
        textAlign: "center",
        padding: "1rem",
      }}
    >
      <div>
        No more free renders available.
        <br />
        Upgrade your account to get unlimited free renders.
      </div>
      <div
        style={{
          padding: "1rem",
        }}
      >
        <Button
          type="primary"
          style={{
            borderRadius: "0.2rem",
            backgroundColor: "#447ce9",
            border: "none",
            fontWeight: 600,
            fontSize: "12px",
          }}
          onClick={() => {
            handleClick();
          }}
        >
          Upgrade
        </Button>{" "}
      </div>
    </div>
  );
}
